export const ModalTypes = {
  OPEN_FREE_ROUND_DETAILS: "OPEN_FREE_ROUND_DETAILS",
};
